<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path d="M57 35.33h-6.5v-7.66a2 2 0 00-2-2H42V18a2 2 0 00-2-2H24a2 2 0 00-2 2v7.67h-6.5a2 2 0 00-2 2v7.66H7a2 2 0 00-2 2V46a2 2 0 002 2h50a2 2 0 002-2v-8.66a2 2 0 00-2-2.01zm-9.5-6.66v6.66h-14v-6.66h14zM25 19h14v6.67H25zm-8.5 9.67h14v6.66h-14zM22 45H8v-6.67h14zm17 0H25v-6.67h14zm17 0H42v-6.67h14z"/></svg>